import { render, staticRenderFns } from "./create-quiz.html?vue&type=template&id=30ecf6b6&scoped=true&external"
import script from "./create-quiz.vue?vue&type=script&lang=js"
export * from "./create-quiz.vue?vue&type=script&lang=js"
import style0 from "./create-quiz.css?vue&type=style&index=0&id=30ecf6b6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ecf6b6",
  null
  
)

export default component.exports